import { Modal } from "@ucchub/ui";
import { SuccessModalContent } from "@ucchub/ui/src/Modal";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type AddCommercialCriteria = {
  isOpen: boolean;
  onClose?: () => void;
  heading: string;
  body: ReactNode;
  confirmText: string;
};

const AddCommercialCriteriaSuccessModal = ({
  isOpen,
  onClose,
  heading,
  body,
  confirmText,
}: AddCommercialCriteria) => {
  const handleOnClose = () => {
    onClose?.();
  };
  const { t } = useTranslation();

  return (
    <Modal
      srName={t(
        "core:commercialCriteria:add_commercial_criteria.added_successfully"
      )}
      isOpen={isOpen}
      size={2}
      animate
      isClosable
      onClose={handleOnClose}
    >
      <SuccessModalContent
        heading={heading}
        body={body}
        confirmText={confirmText}
        onConfirm={handleOnClose}
      />
    </Modal>
  );
};

export default AddCommercialCriteriaSuccessModal;
